import { useDataAuth } from './useDataAuth';
import { SaveFiles, SaveData, FinishSignature } from "../services/digitalSignature.service";
import moment from 'moment';

export const useManageDigitalSignature = () => {
    const [{ userSession }] = useDataAuth();
    const pages = [];
    const id_unique = Date.now();
    const dateTime2 = moment(new Date()).format("YYYY/MM/DD");

    const HandleSave = async (file, images, signedObjects, recipients) => {
        SaveImages(images);
        let url = await SaveOriginalFile(file);
        let nameFile = file.name;

        let obj = JSON.stringify({
            "id_unique": id_unique.toString(),
            "name": nameFile,
            "duo_date": moment().format(),
            "bucket": "ia-automation-storage-staging",
            "original_document": [{ url }],
            "status": "setting",
            "pages": GetPages(signedObjects),
            "receiver": GetReceiver(signedObjects, recipients)
        });
        console.log(obj);
        const base64String = Buffer.from(obj).toString('base64');
        const res = await SaveData(userSession.token, base64String);
        console.log('HandleSave_res ', res);
    }

    const SaveImages = async (images) => {
        let cont = 1;
        for (const item of images) {
            const dto = {
                "id": `900114098/${dateTime2}/${id_unique}`,
                "name": `page_${cont}.png`,
                "file": item.url_page.split(",")[1]
            };
            cont++
            const res = await SaveFiles(userSession.token, dto);
            pages.push({ ...item, url_page: res.data.path });
        };
    }

    const SaveOriginalFile = async (file) => {
        if (file && file.type === "application/pdf") {
            try {
                const base64String = await convertFileToBase64(file);
                const dto = {
                    "id": `900114098/${dateTime2}/${id_unique}`,
                    "name": file.name,
                    "file": base64String
                };
                const res = await SaveFiles(userSession.token, dto);
                return res.data.path;
            } catch (error) {
                console.error('Error al convertir el archivo:', error);
            }
        }
    }

    const convertFileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const base64String = reader.result.split(",")[1];
                resolve(base64String);
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsDataURL(file);
        });
    };

    const GetPages = (objectSing) => {
        const obj = pages.map(item => {
            const signature = Array.isArray(item.signature) ? item.signature : [];
            const signs = objectSing.filter(e => (e.pageIndex + 1).toString() === item.order);
            return { ...item, signature: [...signature, ...signs] };
        });
        return obj;
    }

    const GetReceiver = (objectSing, recipients) => {
        const receiver = objectSing.map(item => {
            const rec = recipients.find(e => e.email === item.receiver_email);
            if (rec)
                return { ...rec, type: item.type, page: (item.pageIndex + 1).toString() };
            return null;
        }).filter(Boolean);
        return receiver;
    }

    const SendSignatureToEmail = async () => {
        const res = await FinishSignature(userSession.token, id_unique.toString());
        console.log('SendSignatureToEmail_res ', res);
    }

    return [{
        HandleSave,
        SendSignatureToEmail
    }];
}